import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export type UpdateSupplier = {
  name: string;
};

export const emptySupplier: UpdateSupplier = {
  name: '',
};

export function updateSupplier(id: number, supplier: UpdateSupplier) {
  return fetchWrapper({
    url: `/api/supplier/${id}`,
    fetchArg: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: supplier,
    },
  });
}
